import React, { useContext, useMemo } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { campaignLanguageStrings } from '@bingads-webui-campaign-react/language-target';

export const Languages = ({ data }) => {
  const i18n = useContext(I18nContext);

  // format languages
  const formattedLanguages = useMemo(() => _.map(data, language => i18n.getString(campaignLanguageStrings[language] || language)).toString(), [i18n, data]);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Languages') }}>
      <Text>{formattedLanguages}</Text>
    </PropertyRow>
  );
};

Languages.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string),
};

Languages.defaultProps = {
  data: [],
};
